import { Link } from "react-router-dom";

export default function Navbar() {
  const linkStyle = {
    color: "#f8f9fa",
    fontSize: "0.95rem",
    textDecoration: "none",
    backgroundColor: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.16)",
    borderRadius: "999px",
    padding: "0.5rem 1rem",
    transition: "all 0.2s ease",
  };

  return (
    <header
      style={{
        background:
          "linear-gradient(180deg, rgba(5,11,24,0.95) 0%, rgba(8,18,36,0.92) 100%)",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
      }}
    >
      <nav className="navbar navbar-expand-lg px-3 px-lg-4 py-3">
        <div className="container-fluid">
          <Link
            to="/"
            className="navbar-brand d-flex align-items-center gap-2 text-white fw-semibold m-0"
            style={{
              textDecoration: "none",
              fontSize: "1rem",
              letterSpacing: "0.02em",
            }}
          >
            <span>TITÁN</span>
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTitan"
            aria-controls="navbarTitan"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{
              border: "1px solid rgba(255,255,255,0.18)",
              backgroundColor: "rgba(255,255,255,0.06)",
              boxShadow: "none",
            }}
          >
            <span
              className="navbar-toggler-icon"
              style={{ filter: "invert(1) brightness(2)" }}
            />
          </button>

          <div
            className="collapse navbar-collapse justify-content-end mt-3 mt-lg-0"
            id="navbarTitan"
          >
            <div className="navbar-nav d-flex align-items-start align-items-lg-center gap-2">
              <Link to="/" className="nav-link" style={linkStyle}>
                Inicio
              </Link>

              <Link to="/login" className="nav-link" style={linkStyle}>
                Login
              </Link>

              <Link
                to="/register"
                className="nav-link"
                style={{
                  ...linkStyle,
                  backgroundColor: "#f8f9fa",
                  color: "#081224",
                  fontWeight: 600,
                  border: "1px solid rgba(255,255,255,0.35)",
                }}
              >
                Registrarse
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
